import React from 'react';
import GoogleMap from 'google-map-react';
import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withTranslations } from '../../HoCs';
import Component from '../Component';
import styles from './styles';
import Pin from '../../resources/vectors/pin';
import { isEmptyList, isEmptyObject, path } from '../../utils';
import { debounce } from '../../utils/functionUtils';

class LocationPicker extends Component {

    defaultCenter = { lat: 28.612833, lng: 77.231163 };

    API_KEY = 'AIzaSyC9tPpVLcjk83cORbHTHuwCYK8QK94f1-Y';

    styles = styles;

    state = {
        mapsRef: null,
        autocompleteSessionToken: null,
        query: '',
        open: false,
        loading: false,
        options: [],
    }

    hasStateUpdate = prevState => prevState.open !== this.state.open || prevState.loading !== this.state.loading || prevState.options !== this.state.options || prevState.query !== this.state.query

    componentDidMount = () => this.updateLocation(this.props.center);
    componentDidUpdate = (pProps, pState) => {
        if (this.hasStateUpdate(pState)) return;
        JSON.stringify(this.props.center) !== JSON.stringify(this.getCenter()) && this.updateLocation(this.props.center);
    }

    updateLocation = center => center && this.state.mapsRef && ((this.state.mapsRef.map.panTo(center), this.state.mapsRef.map.setZoom(this.props.zoom)));

    getCenter = () => ({ lat: path(this.state.mapsRef, 'map.center.lat', () => { })(), lng: path(this.state.mapsRef, 'map.center.lng', () => { })() });

    onMapLoaded = mapsRef => this.setState({ mapsRef, mapsSessionToken: mapsRef.maps.places.AutocompleteSessionToken() });

    onConfirm = () => new this.state.mapsRef.maps.Geocoder().geocode({ location: this.getCenter() }, response => {
        !isEmptyList(response) && this.props.onPicked({ location: this.getCenter(), address: response[0].formatted_address });
    });

    render = () => <div style={this.gs('container')}>
        <GoogleMap bootstrapURLKeys={{ key: this.API_KEY, libraries: ['places'] }} defaultCenter={this.defaultCenter} defaultZoom={this.props.zoom} options={{ fullscreenControl: false }} yesIWantToUseGoogleMapApiInternals onGoogleApiLoaded={this.onMapLoaded} />
        <div style={this.gs('search')}>{this.renderInput()}</div>
        <Pin style={this.gs('pin')} />
        <ButtonBase style={this.gs('confirm')} onClick={this.onConfirm}>{this.guc('confirm_location')}</ButtonBase>
    </div>;

    setOpen = open => () => this.setState({ open });

    getSuggestions = () => {
        if (this.state.query.length < 3) return;
        new this.state.mapsRef.maps.places.AutocompleteService().getPlacePredictions({
            input: this.state.query, sessionToken: this.state.autocompleteSessionToken,
        }, response => this.setState(pState => ({
            options: !isEmptyList(response) ? response : pState.options,
            loading: false
        })));
    }
    debouncer = debounce(this.getSuggestions, 1000);
    onQueryChange = (e, value) => this.setState({ query: value }, this.debouncer);

    onPlaceSelected = (e, value) => {
        if (isEmptyObject(value)) return;
        new this.state.mapsRef.maps.places.PlacesService(this.state.mapsRef.map).getDetails({
            placeId: value.place_id, fields: ['geometry'], sessionToken: this.sessionToken
        }, response => !isEmptyObject(path(response.geometry, 'location') &&
            this.updateLocation({ lat: response.geometry.location.lat(), lng: response.geometry.location.lng() })
        ));
    }

    renderInput = () => <Autocomplete style={{ width: '100%' }} open={this.state.open} onOpen={this.setOpen(true)} onClose={this.setOpen(false)}
        getOptionSelected={(option, value) => option.description === value.description} filterOptions={x => x} forcePopupIcon={false}
        getOptionLabel={(option) => option.description} options={this.state.options}
        onChange={this.onPlaceSelected} onInputChange={this.onQueryChange} size='small'
        renderInput={params => <TextField {...params} label={this.guc('Search')} variant="outlined" />}
    />;

}

LocationPicker.defaultProps = {
    zoom: 15,
}

export default withTranslations(LocationPicker);
